'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colorMethods = require('./colorMethods');

var _colorMethods2 = _interopRequireDefault(_colorMethods);

var _addModifier = require('./addModifier');

var _addModifier2 = _interopRequireDefault(_addModifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add useful methods directly to selector function, as well as put an rgbString() call at the end
 * @param selector
 */
var decorateSelector = function decorateSelector(selector) {
  // add member functions to our selector
  _colorMethods2.default.forEach(function (method) {
    selector[method] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return decorateSelector(_addModifier2.default.apply(undefined, [selector, method].concat(args)));
    };
  });
  return selector;
};

exports.default = decorateSelector;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-theme/lib/decorateSelector.js
// module id = 1027
// module chunks = 0